import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import PublicNavBar from '../../components/layout/PublicNavBar';
import SiteFooter from '../../components/layout/SiteFooter';

const MarketingConsentCollectionPage: React.FC = () => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  // The page is usually opened in a new tab (window.open). In that case there
  // is no in-app history to go back to, so close the tab; otherwise navigate
  // back, falling back to the profile info page.
  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      window.close();
      // If the tab wasn't script-opened (close blocked), go somewhere sane.
      setTimeout(() => navigate('/my-profile/info'), 50);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <PublicNavBar />
      <div className="flex-1 py-12 px-4">
      <div className="max-w-2xl mx-auto bg-white rounded-xl shadow-sm border border-gray-200 p-8">
        <h1 className="text-xl font-bold text-gray-900 mb-6">
          {t('consentCollection.title')}
        </h1>

        <div className="space-y-6 text-sm text-gray-700">
          <div className="border-b border-gray-100 pb-4">
            <h2 className="font-semibold text-gray-800 mb-2">{t('consentCollection.purposeLabel')}</h2>
            <p>{t('consentCollection.purposeValue')}</p>
          </div>

          <div className="border-b border-gray-100 pb-4">
            <h2 className="font-semibold text-gray-800 mb-2">{t('consentCollection.itemsLabel')}</h2>
            <p>{t('consentCollection.itemsValue')}</p>
          </div>

          <div className="border-b border-gray-100 pb-4">
            <h2 className="font-semibold text-gray-800 mb-2">{t('consentCollection.retentionLabel')}</h2>
            <p>{t('consentCollection.retentionValue')}</p>
          </div>

          <p className="text-xs text-gray-500 bg-gray-50 p-3 rounded-lg">
            {t('consentCollection.notice')}
          </p>
        </div>

        <div className="mt-8">
          <button
            onClick={handleBack}
            className="px-4 py-2 text-sm font-medium text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            {t('consentCollection.back')}
          </button>
        </div>
      </div>
      </div>
      <SiteFooter />
    </div>
  );
};

export default MarketingConsentCollectionPage;
